import NudgedRow from '../store/schema/NudgedRow';
import { getStore } from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isSpotlightItem(itemOrConversationId: string): boolean {
    // An item is never a spotlight item if the feature isn't enabled.
    if (!isFeatureEnabled('tri-spotlight')) {
        return false;
    }

    return getStore().nudgedRows.some(
        (nudgedRow: NudgedRow) =>
            (nudgedRow.conversationId === itemOrConversationId ||
                nudgedRow.itemId === itemOrConversationId) &&
            nudgedRow.daysAgo === 0
    );
}
